import Image from "next/image";
import Link from "next/link";


export default function Poster({className, event}) {
    const height = 170;
    return (
        <Link href={'/theater-details/' + event.slug} passHref>
            <a className={`${className}  cursor-pointer m-2`}>
                <Image
                    src={event.poster || event.picture || '/assets/images/curtain.jpg'}
                    width={0.8 * height}
                    height={height}
                />
            </a>
        </Link>
    );
}

